import { render, staticRenderFns } from "./memberWrapper.vue?vue&type=template&id=b1ed5cd6"
import script from "./memberWrapper.vue?vue&type=script&lang=js"
export * from "./memberWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports